import { useParams } from 'react-router-dom';

export function useTransactionIdFromUrl(): string | null {
  const { transactionId } = useParams<{ transactionId?: string }>();
  return transactionId ?? null;
}
